module.exports = __webpack_public_path__ + "static/media/user-follow-line_yes.a49c363e.svg";